import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';
import classes from './IAndCArchiveAdvisor.module.css';
import { pushToError } from '../../../../utils/common';
class IAndCArchiveAdvisor extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    this.props.setCurrentRouteState('aa/advisor', 'I&C Archive');
    if (!this.props.userfleetApiLoading) {
      $('.' + classes.IAndCArchiveAdvisor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}aa/aa.static/recommendations-static.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then(responseAdvisor => {
              $('#angularContainer').load(window.makeTextFile(responseAdvisor.data));
              this.setState({
                htmlApiLoading: false
              });
            })
            .catch(errAdvisor => {
              console.error(errAdvisor);
              pushToError(this.props,this.state.pname,errAdvisor,url);
            });
        }
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userfleetApiLoading !== this.props.userfleetApiLoading) {
      this.setState({
        htmlApiLoading: true
      });
      $('.' + classes.IAndCArchiveAdvisor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}aa/aa.static/recommendations-static.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then(responseData => {
              $('#angularContainer').load(window.makeTextFile(responseData.data));
              this.setState({
                htmlApiLoading: false
              });
            })
            .catch(error => {
              console.error(error);
              pushToError(this.props,this.state.pname,error,url);
            });
        }
      );
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading || this.props.userfleetApiLoading ? (
          <LoadingScreen />
        ) : null}
        <div className={classes.IAndCArchiveAdvisor}></div>
      </React.Fragment>
    );
  }
}

export default IAndCArchiveAdvisor;
